import React, {useState} from 'react';
import { TextField, Button, Paper, Box, Typography } from '@mui/material';
import { ThemeProvider, styled } from '@mui/material/styles';
import { useFormik } from 'formik';
import * as yup from 'yup';
import centeredImage from '../assets/images/trailai-small-logo.png'; // Import the image

// Import the custom theme
import customTheme from './theme'; // Adjust the path if needed

const theme = customTheme

const CenteredImage = styled(Box)(({ theme }) => ({
  zIndex: 0, // Ensure the image is behind the container if needed
}));

const LoginForm = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object({
    email: yup.string().email('Invalid email address').required('Email is required'),
    password: yup.string().min(6, 'Password must be at least 6 characters').required('Password is required'),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      setError('');

      try {
        const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
        const response = await fetch(`${API_BASE_URL}/hrbot/frontend/generate_frontend_jwt_token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(values), // Formik's values object
        });

        const data = await response.json();

        if (response.ok) {
          // Authentication successful
          console.log('Login successful:', data);
          localStorage.setItem('authToken', data.token);
          localStorage.setItem('chatbots', JSON.stringify(data.chatbots));
          window.location.href = '/chatbot';
        } else {
          // Authentication failed
          console.error('Login failed:', data);
          setError(data.message || 'Invalid email or password');
        }
      } catch (error) {
        console.error('Error during login:', error);
        setError('An unexpected error occurred');
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <ThemeProvider theme={customTheme}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2, // Optional: Adds spacing between the boxes (using theme spacing)
        }}
      >
        <CenteredImage sx={{
            display: 'flex',
            padding: theme.spacing(4), justifyContent: 'center', alignItems:'center', width: '100%',
            maxWidth: 400, alignContent:"center"}} >
          <img src={centeredImage} style={{ maxWidth: '100%', maxHeight: '80vh' }} alt="" />
        </CenteredImage>
        <Paper
          //elevation={3}
          sx={{
            padding: theme.spacing(4),
            width: '100%',
            maxWidth: 400,
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <Typography
            variant="h4"
            align="center"
            marginBottom={theme.spacing(3)}
            color={theme.palette.primary.main}
          >
            Login
          </Typography>
          {error && (
            <Typography color="error" align="center" marginBottom={theme.spacing(2)}>
              {error}
            </Typography>
          )}
          <form onSubmit={formik.handleSubmit}>
            <TextField
              fullWidth
              id="email"
              name="email"
              label="Email"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              margin="normal"
              variant="outlined"
              color="primary"
            />
            <TextField
              fullWidth
              id="password"
              name="password"
              label="Password"
              type="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              margin="normal"
              variant="outlined"
              color="primary"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ marginTop: theme.spacing(3) }}
              disabled={loading || !formik.isValid}
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>
        </Paper>
      </Box>
      </ThemeProvider>
  );
};


export default LoginForm;
